exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreeWrap[data-v-0dce8669]{font-size:.213333rem;padding:.133333rem;line-height:.506667rem;background:#fff}.agreeWrap h6[data-v-0dce8669]{font-size:.266667rem}.agreeWrap li[data-v-0dce8669]{margin:.133333rem 0}.agreeWrap .ql-indent-1[data-v-0dce8669]{text-indent:.133333rem}.agreeWrap .ql-indent-2[data-v-0dce8669]{text-indent:.4rem}.agreeWrap .ql-indent-3[data-v-0dce8669]{text-indent:.666667rem}", ""]);

// exports
